import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import styled from 'styled-components';

import { Container, OverlayText } from './styled';

type DashboardItemProps = {
  hasData: boolean;
} & PropsWithChildren;

export const DashboardItem: FC<DashboardItemProps> = ({ hasData, children }) => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'dashboard' });

  return (
    <Container>
      {!hasData && <OverlayText>{t('noData')}</OverlayText>}
      <Item className={cn({ blurred: !hasData })}>{children}</Item>
    </Container>
  );
};

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &.blurred {
    filter: blur(10px);
    pointer-events: none;
    user-select: none;
  }
`;
